import { render, staticRenderFns } from "./edit3.vue?vue&type=template&id=21f4908d&scoped=true"
import script from "./edit3.vue?vue&type=script&lang=js"
export * from "./edit3.vue?vue&type=script&lang=js"
import style0 from "./edit3.vue?vue&type=style&index=0&id=21f4908d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f4908d",
  null
  
)

export default component.exports